// 一頁式商店 JavaScript

(function() {
  'use strict';

  // 初始化
  document.addEventListener('DOMContentLoaded', function() {
    initVariantSelectors();
    initAddToCart();
    initRemoveFromCart();
    initModal();
    updateCartDisplay();
    updateAllProductCartStates();
  });

  // 子類選擇器功能
  function initVariantSelectors() {
    const variantSelectors = document.querySelectorAll('.variant-selector');
    
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        const productId = this.dataset.productId;
        const selectedOption = this.options[this.selectedIndex];
        const variantId = selectedOption.value;
        const variantPrice = selectedOption.dataset.price;
        const isAvailable = !selectedOption.disabled;
        
        // 找到對應的商品卡片
        const productCard = this.closest('.product-card');
        productCard.dataset.variantId = variantId;
        
        // 更新價格顯示
        const priceDisplay = productCard.querySelector('[data-product-price-display] .price-amount');
        if (priceDisplay) {
          priceDisplay.textContent = formatMoney(parseInt(variantPrice));
        }
        
        // 更新按鈕的 variant ID
        const addBtn = productCard.querySelector('.btn-add-to-cart');
        const removeBtn = productCard.querySelector('.btn-remove-from-cart');
        if (addBtn) addBtn.dataset.variantId = variantId;
        if (removeBtn) removeBtn.dataset.variantId = variantId;
        
        // 更新按鈕狀態
        updateProductCartState(productCard, variantId);
      });
    });
  }

    // 加入購物車功能
  function initAddToCart() {
    document.addEventListener('click', function(e) {
      const button = e.target.closest('.btn-add-to-cart');
      if (!button) return;
      
      e.preventDefault();
      
      const variantId = button.dataset.variantId;
      const productCard = button.closest('.product-card');
      const btnIconText = button.querySelector('.btn-icon-text');
      const btnSuccessIcon = button.querySelector('.btn-success-icon');
      
      // 顯示載入狀態
      btnIconText.style.opacity = '0.5';
      button.disabled = true;
      
      // Ajax 加入購物車
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // 成功加入 - 顯示勾勾
        button.classList.add('added');
        btnIconText.style.display = 'none';
        btnSuccessIcon.style.display = 'inline-block';
        
        // 更新購物車顯示
        updateCartDisplay();
        updateProductCartState(productCard, variantId);
        
        // 0.6秒後恢復按鈕
        setTimeout(() => {
          button.classList.remove('added');
          btnIconText.style.display = 'inline-block';
          btnIconText.style.opacity = '1';
          btnSuccessIcon.style.display = 'none';
          button.disabled = false;
        }, 600);
      })
      .catch(error => {
        console.error('Error:', error);
        btnIconText.textContent = '✗';
        btnIconText.style.opacity = '1';
        button.disabled = false;
        
        setTimeout(() => {
          btnIconText.textContent = '+';
        }, 1500);
      });
    });
  }

  // 移除購物車功能（每次減少 1 件）
  function initRemoveFromCart() {
    document.addEventListener('click', function(e) {
      const button = e.target.closest('.btn-remove-from-cart');
      if (!button) return;
      
      e.preventDefault();
      
      const variantId = button.dataset.variantId;
      const productCard = button.closest('.product-card');
      const btnIconText = button.querySelector('.btn-icon-text');
      const btnSuccessIcon = button.querySelector('.btn-success-icon');
      
      // 顯示載入狀態
      btnIconText.style.opacity = '0.5';
      button.disabled = true;
      button.classList.add('removing');
      
      // 先取得購物車資料，找到對應的 line item
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // 找到對應的商品行
          const lineItem = cart.items.find(item => item.variant_id == variantId);
          
          if (lineItem && lineItem.quantity > 0) {
            // 減少 1 件
            const newQuantity = lineItem.quantity - 1;
            
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: variantId,
                quantity: newQuantity
              })
            });
          } else {
            throw new Error('商品不在購物車中');
          }
        })
        .then(response => response.json())
        .then(data => {
          // 成功移除 - 顯示勾勾
          btnIconText.style.display = 'none';
          btnSuccessIcon.style.display = 'inline-block';
          
          // 更新購物車顯示
          updateCartDisplay();
          updateProductCartState(productCard, variantId);
          
          // 0.6秒後恢復按鈕
          setTimeout(() => {
            button.classList.remove('removing');
            btnIconText.style.display = 'inline-block';
            btnIconText.style.opacity = '1';
            btnSuccessIcon.style.display = 'none';
            button.disabled = false;
          }, 600);
        })
        .catch(error => {
          console.error('Error:', error);
          btnIconText.textContent = '✗';
          btnIconText.style.opacity = '1';
          button.disabled = false;
          button.classList.remove('removing');
          
          setTimeout(() => {
            btnIconText.textContent = '−';
          }, 1500);
        });
    });
  }


  // 更新單一商品的購物車狀態
  function updateProductCartState(productCard, variantId) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const lineItem = cart.items.find(item => item.variant_id == variantId);
        const quantity = lineItem ? lineItem.quantity : 0;
        
        const removeBtn = productCard.querySelector('.btn-remove-from-cart');
        const badge = productCard.querySelector('[data-cart-badge]');
        const badgeCount = badge.querySelector('.badge-count');
        
        // 更新數量標籤
        if (quantity > 0) {
          if (badge) {
            badge.style.display = 'block';
            badgeCount.textContent = quantity;
          }
          // 啟用移除按鈕
          if (removeBtn) {
            removeBtn.disabled = false;
          }
        } else {
          if (badge) badge.style.display = 'none';
          // 禁用移除按鈕
          if (removeBtn) {
            removeBtn.disabled = true;
          }
        }
      })
      .catch(error => console.error('Error updating product state:', error));
  }

  // 更新所有商品的購物車狀態
  function updateAllProductCartStates() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const productCards = document.querySelectorAll('.product-card');
        
        productCards.forEach(card => {
          const variantId = card.dataset.variantId;
          const lineItem = cart.items.find(item => item.variant_id == variantId);
          const quantity = lineItem ? lineItem.quantity : 0;
          
          const removeBtn = card.querySelector('.btn-remove-from-cart');
          const badge = card.querySelector('[data-cart-badge]');
          const badgeCount = badge ? badge.querySelector('.badge-count') : null;
          
          if (quantity > 0) {
            if (badge) {
              badge.style.display = 'block';
              badgeCount.textContent = quantity;
            }
            if (removeBtn) {
              removeBtn.disabled = false;
            }
          } else {
            if (badge) badge.style.display = 'none';
            if (removeBtn) {
              removeBtn.disabled = true;
            }
          }
        });
      })
      .catch(error => console.error('Error updating all product states:', error));
  }

  // 更新購物車顯示
  function updateCartDisplay() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemCount = cart.item_count;
        const totalPrice = formatMoney(cart.total_price);
        
        // 更新頂部購物車總計
        document.getElementById('cart-item-count').textContent = itemCount;
        document.getElementById('cart-total-price').textContent = totalPrice;
        
        // 更新底部結帳區
        document.getElementById('checkout-item-count').textContent = itemCount;
        document.getElementById('checkout-total-price').textContent = totalPrice;
        
        // 更新所有商品狀態
        updateAllProductCartStates();
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // 格式化金額
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(0);
    return 'NT$' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // 彈窗功能
  function initModal() {
    const modal = document.getElementById('product-modal');
    const modalClose = document.querySelector('.modal-close');
    const modalTriggers = document.querySelectorAll('[data-modal-trigger]');
    
    // 開啟彈窗
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const title = this.dataset.productTitle;
        const price = this.dataset.productPrice;
        const image = this.dataset.productImage;
        const description = this.dataset.productDescription;
        
        document.getElementById('modal-title').textContent = title;
        document.getElementById('modal-price').textContent = price;
        document.getElementById('modal-image').src = image;
        document.getElementById('modal-description').innerHTML = description;
        
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
    });
    
    // 關閉彈窗
    modalClose.addEventListener('click', closeModal);
    
    window.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });
    
    function closeModal() {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  }

})();
